import { __rest } from 'tslib';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import MuiTypography from '@mui/material/Typography';
import InspectorWidget from '../../InspectorWidget/InspectorWidget.js';
import GroupInner from './GroupInner.js';

const GroupTitle = styled(MuiTypography) `
  color: ${({ theme }) => theme.palette.N10.main};
  margin-top: 4px;
`;
const Separator = styled('hr') `
  border-top: 1px solid ${({ theme }) => theme.palette.N20.main};
  border-bottom: none;
`;
const Group = (_a) => {
    var { setting, collapsibleGroup } = _a, rest = __rest(_a, ["setting", "collapsibleGroup"]);
    const { name, removeSeparator } = setting;
    return collapsibleGroup ? (jsx(InspectorWidget, Object.assign({ title: name, noHorizontalPadding: true, hideIcon: true, defaultIsOpen: true }, { children: jsx(GroupInner, Object.assign({ setting: setting }, rest)) }))) : (jsxs(Fragment, { children: [jsx(GroupTitle, Object.assign({ variant: "h4" }, { children: name })), jsx(GroupInner, Object.assign({ setting: setting }, rest)), removeSeparator ? null : jsx(Separator, {})] }));
};

export { Group as default };
//# sourceMappingURL=Group.js.map
